// extracted by mini-css-extract-plugin
export var deleteModal = "_gm-0";